import {inject, injectable} from "inversify";
import ApiService from "./apiService";
import {TourPathApi, TourPathCreateDto, TourPathDto} from "../api";

@injectable()
export default class TourPathService {
    constructor(@inject(ApiService) private readonly apiService: ApiService) {}

    async getPublic() {
        const response = await this.apiService.getApi(TourPathApi).apiTourPathPublicGet();
        return response.data || [];
    }

    async getMine() {
        const response = await this.apiService.getApi(TourPathApi).apiTourPathMineGet();
        return response.data || [];
    }

    async getAdminAll() {
        const response = await this.apiService.getApi(TourPathApi).apiTourPathGet();
        return response.data || [];
    }

    async createPublic(payload: TourPathCreateDto) {
        const response = await this.apiService.getApi(TourPathApi).apiTourPathPost(payload);
        return response.data!;
    }

    async updatePublic(id: number, payload: TourPathCreateDto) {
        const response = await this.apiService.getApi(TourPathApi).apiTourPathIdPut(id, payload);
        return response.data!;
    }

    async deletePublic(id: number) {
        await this.apiService.getApi(TourPathApi).apiTourPathIdDelete(id);
    }

    async createOwn(payload: TourPathCreateDto) {
        const response = await this.apiService.getApi(TourPathApi).apiTourPathMinePost(payload);
        return response.data!;
    }

    async updateOwn(id: number, payload: TourPathCreateDto) {
        const response = await this.apiService.getApi(TourPathApi).apiTourPathMineIdPut(id, payload);
        return response.data!;
    }

    async deleteOwn(id: number) {
        await this.apiService.getApi(TourPathApi).apiTourPathMineIdDelete(id);
    }
}
